"use strict";
import { createApprovalTransactionStep } from "features/transactions/steps/approve";
import { createPermit2SignatureStep } from "features/transactions/steps/permit2Signature";
import { createPermit2TransactionStep } from "features/transactions/steps/permit2Transaction";
import { createRevocationTransactionStep } from "features/transactions/steps/revoke";
import { createWrapTransactionStep } from "features/transactions/steps/wrap";
import { orderClassicSwapSteps } from "features/transactions/swap/steps/classicSteps";
import { createSignUniswapXOrderStep } from "features/transactions/swap/steps/signOrder";
import {
  createSwapTransactionAsyncStep,
  createSwapTransactionStep,
  createSwapTransactionStepBatched
} from "features/transactions/swap/steps/swap";
import { orderUniswapXSteps } from "features/transactions/swap/steps/uniswapxSteps";
import { isValidSwapTxContext } from "features/transactions/swap/types/swapTxAndGasInfo";
import { isBridge, isClassic, isUniswapX } from "features/transactions/swap/utils/routing";
export function generateSwapTransactionSteps(txContext, v4Enabled = false) {
  const isValidSwap = isValidSwapTxContext(txContext);
  if (isValidSwap) {
    const { trade, approveTxRequest, revocationTxRequest } = txContext;
    const revocation = createRevocationTransactionStep(revocationTxRequest, trade.inputAmount.currency.wrapped);
    const approval = createApprovalTransactionStep(approveTxRequest, trade.inputAmount);
    if (isClassic(txContext)) {
      const { swapRequestArgs } = txContext;
      if (txContext.unsigned) {
        return orderClassicSwapSteps({
          revocation,
          approval,
          permit: createPermit2SignatureStep(txContext.permit.typedData, trade.inputAmount.currency),
          swap: createSwapTransactionAsyncStep(swapRequestArgs, v4Enabled)
        });
      }
      if (txContext.txRequests.length > 1) {
        return orderClassicSwapSteps({
          permit: void 0,
          swap: createSwapTransactionStepBatched(txContext.txRequests)
        });
      }
      const permit = txContext.permit ? createPermit2TransactionStep(txContext.permit.txRequest, trade.inputAmount) : void 0;
      return orderClassicSwapSteps({
        revocation,
        approval,
        permit,
        swap: createSwapTransactionStep(txContext.txRequests[0])
      });
    } else if (isUniswapX(txContext)) {
      return orderUniswapXSteps({
        revocation,
        approval,
        wrap: createWrapTransactionStep(txContext.wrapTxRequest, trade.inputAmount),
        signOrder: createSignUniswapXOrderStep(txContext.permit.typedData, txContext.trade.quote.quote)
      });
    } else if (isBridge(txContext)) {
      if (txContext.txRequests.length > 1) {
        return orderClassicSwapSteps({
          permit: void 0,
          swap: createSwapTransactionStepBatched(txContext.txRequests)
        });
      }
      return orderClassicSwapSteps({
        revocation,
        approval,
        permit: void 0,
        swap: createSwapTransactionStep(txContext.txRequests[0])
      });
    }
  }
  return [];
}
